<template>
  <!--  -->
  <div class="md:flex md:space-y-0 space-y-5" :class="wrapperClass">
    <!--  -->
    <div
      class="flex items-center space-x-4"
      v-if="enableSearch"
      :class="searchClasss"
    >
      <!--  -->
      <div
        class="flex items-center space-x-2"
        v-if="enableSearch && enableInput"
      >
        <!--  -->
        <input
          v-model.number="input"
          class="form-control w-9 overflow-auto h-9"
          type="text"
          placeholder="0"
        />
        <!--  -->
        <div
          @click.prevent="changePage(input)"
          class="flex-0 cursor-pointer text-sm h-9 w-9 bg-slate-900 text-white flex items-center justify-center rounded"
        >
          {{ $t("go") }}
        </div>
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <div class="flex items-center" v-if="enableSearch && enableSelect">
        <!--  -->
        <Select
          v-model.number="input2"
          @change="changePage(input2)"
          placeholder="Go"
          classInput=" w-[60px] h-9 "
          :options="options"
        >
          <!--  -->
        </Select>
        <!--  -->

        <!--  -->
        <span class="text-sm text-slate-500 inline-block ml-2">
          {{ `${$t("of")} ${perPage} ${$t("entries")}` }}
        </span>
        <!--  -->
      </div>
      <!--  -->
    </div>
    <!--  -->

    <!--  -->
    <ul class="pagination" :class="paginationClass">
      <!--  -->
      <li class="text-xl leading-4 text-slate-900">
        <!--  -->
        <button
          @click.prevent="changePage(prevPage)"
          :disabled="current === 1"
          :class="current === 1 ? ' opacity-50 cursor-not-allowed' : ''"
        >
          <!--  -->
          <Icon icon="heroicons-outline:chevron-left" v-if="!enableText" />
          <!--  -->

          <!--  -->
          <span v-if="enableText" class="text-sm inline-block">Previous</span>
          <!--  -->
        </button>
        <!--  -->
      </li>
      <!--  -->

      <!--  -->
      <li class="" v-if="hasFirst()">
        <!--  -->
        <button @click.prevent="changePage(1)">
          <!--  -->
          <div>
            <!--  -->
            <span> 1 </span>
            <!--  -->
          </div>
          <!--  -->
        </button>
        <!--  -->
      </li>
      <!--  -->

      <!--  -->
      <li class="text-slate-600" v-if="hasFirst()">...</li>
      <!--  -->

      <!--  -->
      <li class="" v-for="(page, i) in pages" :key="i">
        <!--  -->
        <button @click.prevent="changePage(page)">
          <!--  -->
          <div
            :class="{
              active: current === page,
            }"
            class=""
          >
            <!--  -->
            <span class="">{{ page }}</span>
            <!--  -->
          </div>
          <!--  -->
        </button>
        <!--  -->
      </li>
      <!--  -->

      <!--  -->
      <li class="text-slate-600" v-if="hasLast()">...</li>
      <!--  -->

      <!--  -->
      <li class="" v-if="hasLast()">
        <!--  -->
        <button @click.prevent="changePage(totalPages)">
          <!--  -->
          <div>
            <!--  -->
            <span> {{ totalPages }} </span>
            <!--  -->
          </div>
          <!--  -->
        </button>
        <!--  -->
      </li>
      <!--  -->

      <!--  -->
      <li class="text-xl leading-4 text-slate-900">
        <!--  -->
        <button
          @click.prevent="changePage(nextPage)"
          :disabled="current === totalPages"
          :class="
            current === totalPages ? ' opacity-50 cursor-not-allowed' : ''
          "
        >
          <!--  -->
          <Icon icon="heroicons-outline:chevron-right" v-if="!enableText" />
          <!--  -->

          <!--  -->
          <span v-if="enableText" class="text-sm inline-block">Next</span>
          <!--  -->
        </button>
        <!--  -->
      </li>
      <!--  -->
    </ul>
    <!--  -->
  </div>
  <!--  -->
</template>

<script>
import Icon from "@/components/Icon";
import Select from "@/components/Select";

export default {
  name: "Pagination",
  components: {
    Icon,
    Select,
  },
  props: {
    options: {
      type: Array,
      default: () => [{}],
    },
    enableText: {
      type: Boolean,
      default: false,
    },
    enableInput: {
      type: Boolean,
      default: false,
    },
    enableSelect: {
      type: Boolean,
      default: false,
    },
    enableSearch: {
      type: Boolean,
      default: false,
    },
    pageChanged: {
      type: Function,
    },
    perPageChanged: {
      type: Function,
    },
    current: {
      type: Number,
      default: 1,
    },
    total: {
      type: Number,
      default: 0,
    },
    perPage: {
      type: Number,
      default: 10,
    },
    pageRange: {
      type: Number,
      default: 2,
    },
    textBeforeInput: {
      type: String,
      default: "Go to page",
    },
    textAfterInput: {
      type: String,
      default: "Go",
    },
    paginationClass: {
      type: String,
      default: "default",
    },
    searchClasss: {
      type: String,
      default: "default",
    },
    wrapperClass: {
      type: String,
      default: "justify-between",
    },
  },
  data() {
    return {
      input: "",
      input2: null,
    };
  },
  methods: {
    hasFirst: function () {
      return this.rangeStart !== 1;
    },
    hasLast: function () {
      return this.rangeEnd < this.totalPages;
    },
    hasPrev: function () {
      return this.current > 1;
    },
    hasNext: function () {
      return this.current < this.totalPages;
    },
    changePage: function (page) {
      if (page > 0 && page <= this.totalPages) {
        this.$emit("page-changed", page);
      }
      if (this.pageChanged) {
        this.pageChanged({ currentPage: page });
      }
    },
    customPerPageChange(page) {
      this.perPageChanged({ currentPerPage: page });
    },
  },
  computed: {
    pages: function () {
      var pages = [];

      for (var i = this.rangeStart; i <= this.rangeEnd; i++) {
        pages.push(i);
      }

      return pages;
    },
    rangeStart: function () {
      var start = this.current - this.pageRange;

      return start > 0 ? start : 1;
    },
    rangeEnd: function () {
      var end = this.current + this.pageRange;

      return end < this.totalPages ? end : this.totalPages;
    },
    totalPages: function () {
      return Math.ceil(this.total / this.perPage);
    },
    nextPage: function () {
      return this.current + 1;
    },
    prevPage: function () {
      return this.current - 1;
    },
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.pagination li a,
.pagination li div {
  background-color: #e2e8f0;
  color: #19a69d;
  font-size: 0.875rem;
  font-weight: 400;
  border-radius: 0.25rem;
  line-height: 16px;
  display: flex;
  height: 1.5rem;
  width: 1.5rem;
  align-items: center;
  justify-content: center;
  transition: all 150ms;
}

.pagination li a.active,
.pagination li div.active {
  background-color: #19a69d;
  color: #ffffff;
  font-weight: 500;
}

.pagination.bordered {
  border: 1px solid #d8dee6;
  border-radius: 3px;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.pagination.bordered li {
  color: #64748b;
}

.pagination.bordered li:first-child button,
.pagination.bordered li:last-child button {
  color: #64748b;
  height: 1.5rem;
  width: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  transition: all 150ms;
}

.pagination.bordered li:first-child button:hover,
.pagination.bordered li:last-child button:hover {
  background-color: #19a69d;
  color: #ffffff;
}

.pagination.bordered li a,
.pagination.bordered li div {
  background-color: transparent;
  color: #64748b;
}

.pagination.bordered li a.active,
.pagination.bordered li div.active {
  background-color: #19a69d;
  color: #ffffff;
}

.pagination.border-group {
  border: 1px solid #d8dee6;
  border-radius: 3px;
  padding-left: 0;
  padding-right: 0;
  gap: 0;
}

.pagination.border-group li {
  border-right: 1px solid #d8dee5;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  color: #64748b;
}

.pagination.border-group li:last-child {
  border-right: none;
}

.pagination.border-group li a,
.pagination.border-group li div {
  background-color: transparent;
  color: #64748b;
  height: auto;
  width: auto;
}

.pagination.border-group li a.active,
.pagination.border-group li div.active {
  color: #19a69d;
  font-size: 1.125rem;
}
</style>
